import ReactPDF, { Image, Text, View } from "@react-pdf/renderer";
import { styles } from "../style";
import { formatDate } from "../../../../../utils/commonFunctions";
import { renderDocumentType } from "../../../../../utils/invoiceGeneration/commonFunctions";

type AppProps = {
  downloadRevenuesData: any;
};

let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
let blobToken = process.env.REACT_APP_BLOB_TOEKN;

const BillFromAndLogo = ({ downloadRevenuesData }: AppProps) => {

  return (
    <View fixed>
      {/* first column  */}
      <View style={{ ...styles.sub_header_1 }}>
        <View style={{ alignItems: "flex-start", maxWidth: "40%" }}>
          {!!downloadRevenuesData?.primary_details?.logo_details?.file_url
            ?.length ? (
            <Image
              style={{ ...styles.qrCode, marginBottom: "5px" }}
              src={`${blobBaseUrl}${downloadRevenuesData?.primary_details?.logo_details?.file_url}?${blobToken}`}
            />
          ) : null}
          {downloadRevenuesData?.primary_details?.irn ? (
            <View style={styles.flexCenter}>
              <Text style={styles.sub_header}>IRN : </Text>
              <Text style={styles.text}>
                {downloadRevenuesData?.primary_details?.irn}
              </Text>
            </View>
          ) : null}
          {downloadRevenuesData?.primary_details?.ack_no ? (
            <View style={styles.flexCenter}>
              <Text style={styles.sub_header}>Ack No : </Text>
              <Text style={styles.text}>
                {downloadRevenuesData?.primary_details?.ack_no}
              </Text>
            </View>
          ) : null}
          {downloadRevenuesData?.primary_details?.ack_date ? (
            <View style={styles.flexCenter}>
              <Text style={styles.sub_header}>Ack Date : </Text>
              <Text style={styles.text}>
                {formatDate(downloadRevenuesData?.primary_details?.ack_date)}
              </Text>
            </View>
          ) : null}
        </View>
        {downloadRevenuesData?.primary_details?.document_type?.label ? (
          <View style={{ maxWidth: "50%" }}>
            <Text style={styles.heading}>
              {downloadRevenuesData?.primary_details?.document_type?.label}
            </Text>
          </View>
        ) : null}
        {/* Future Use */}
        {/* <View style={{ alignItems: "flex-end", maxWidth: "45%" }}>
          {!!downloadRevenuesData?.primary_details?.logo_details?.file_url
            ?.length ? (
            <Image
              style={styles.qrCode}
              src={`${blobBaseUrl}${downloadRevenuesData?.primary_details?.logo_details?.file_url}?${blobToken}`}
            />
          ) : null}
        </View> */}
      </View>

      {/* second column  */}
      <View style={{ ...styles.sub_header_1 }}>
        <View style={{ alignItems: "flex-start", maxWidth: "40%" }}>
          <Text
            style={{
              ...styles.sub_header,
              textAlign: "left",
              color: "#dd4433",
            }}
          >
            Bill From :{" "}
          </Text>
          {downloadRevenuesData?.primary_details?.bill_from?.trade_name ? (
            <Text style={{ ...styles.text, paddingVertical: "2px" }}>
              {downloadRevenuesData?.primary_details?.bill_from?.trade_name}
            </Text>
          ) : null}

          {downloadRevenuesData?.primary_details?.bill_from_address1 ||
            downloadRevenuesData?.primary_details?.bill_from_address2 ? (
            <Text style={styles.text}>
              {downloadRevenuesData?.primary_details?.bill_from_address1 +
                " " +
                downloadRevenuesData?.primary_details?.bill_from_address2}
            </Text>
          ) : null}
          {downloadRevenuesData?.primary_details?.gst_number ? (
            <View style={styles.flexCenter}>
              <Text style={styles.text_sub_header}>GST : </Text>

              <Text style={{ ...styles.text, marginTop: 0 }}>
                {downloadRevenuesData?.primary_details?.gst_number}
              </Text>
            </View>
          ) : null}
          {downloadRevenuesData?.primary_details?.business_address_details
            ?.pan_number ? (
            <View style={styles.flexCenter}>
              <Text style={styles.text_sub_header}>PAN No : </Text>

              <Text style={styles.text}>
                {
                  downloadRevenuesData?.primary_details
                    ?.business_address_details?.pan_number
                }
              </Text>
            </View>
          ) : null}
          {downloadRevenuesData?.primary_details?.business_address_details
            ?.mobile ? (
            <View style={styles.flexCenter}>
              <Text style={styles.text_sub_header}>Mobile No : </Text>
              <Text style={styles.text}>
                {
                  downloadRevenuesData?.primary_details
                    ?.business_address_details?.mobile
                }
              </Text>
            </View>
          ) : null}
          {downloadRevenuesData?.primary_details?.business_address_details
            ?.pan ? (
            <View style={styles.flexCenter}>
              <Text style={styles.text_sub_header}>Pan : </Text>
              <Text style={styles.text}>
                {
                  downloadRevenuesData?.primary_details
                    ?.business_address_details?.pan
                }
              </Text>
            </View>
          ) : null}

          {downloadRevenuesData?.primary_details?.business_address_details
            ?.email ? (
            <View style={styles.flexCenter}>
              <Text style={styles.text_sub_header}>Email : </Text>
              <Text style={styles.text}>
                {
                  downloadRevenuesData?.primary_details
                    ?.business_address_details?.email
                }
              </Text>
            </View>
          ) : null}
          {downloadRevenuesData?.primary_details?.website ? (
            <View style={styles.flexCenter}>
              <Text style={styles.text_sub_header}>Website : </Text>
              <Text style={styles.text}>
                {downloadRevenuesData?.primary_details?.website}
              </Text>
            </View>
          ) : null}
          <Text
            style={{ ...styles.sub_header, marginTop: 6, color: "#dd4433" }}
          >
            Billing Address :{" "}
          </Text>
          {downloadRevenuesData?.primary_details?.customer_name?.legal_name ? (
            <Text style={{ ...styles.text, paddingVertical: "2px" }}>
              {downloadRevenuesData?.primary_details?.customer_name?.legal_name}
            </Text>
          ) : null}

          {downloadRevenuesData?.primary_details?.customer_address1 ||
            downloadRevenuesData?.primary_details?.customer_address2 ? (
            <Text style={styles.text}>
              <Text>
                {downloadRevenuesData?.primary_details?.customer_address1 +
                  " " +
                  downloadRevenuesData?.primary_details?.customer_address2}
              </Text>
            </Text>
          ) : null}

          <View style={styles.flexCenter}>
            <Text style={{ ...styles.text_sub_header, marginTop: 5 }}>
              GST :{" "}
            </Text>
            <Text style={{ ...styles.text, marginTop: 4 }}>
              {downloadRevenuesData?.primary_details?.customer_gstn
                ? downloadRevenuesData?.primary_details?.customer_gstn
                : "NA"}
            </Text>
          </View>
          <View style={styles.flexCenter}>
            <Text style={styles.text_sub_header}>PAN : </Text>
            <Text style={styles.text}>
              {downloadRevenuesData?.primary_details?.customer_supplier_details
                ?.pan_number
                ? downloadRevenuesData?.primary_details
                  ?.customer_supplier_details?.pan_number
                : "NA"}
            </Text>
          </View>
          <View style={styles.flexCenter}>
            <Text style={styles.text_sub_header}>Email : </Text>
            <Text style={styles.text}>
              {downloadRevenuesData?.primary_details?.customer_supplier_details
                ?.email
                ? downloadRevenuesData?.primary_details
                  ?.customer_supplier_details?.email
                : "NA"}
            </Text>
          </View>
          <View style={styles.flexCenter}>
            <Text style={styles.text_sub_header}>Mobile : </Text>
            <Text style={styles.text}>
              {downloadRevenuesData?.primary_details?.customer_supplier_details
                ?.mobile
                ? downloadRevenuesData?.primary_details
                  ?.customer_supplier_details?.mobile
                : "NA"}
            </Text>
          </View>
          {downloadRevenuesData?.primary_details?.ship_to_address && (
            <Text
              style={{ ...styles.sub_header, marginTop: 6, color: "#dd4433" }}
            >
              Shipping Address :
            </Text>
          )}
          {downloadRevenuesData?.primary_details?.ship_to_address && (
            <View>
              <Text style={styles.text}>
                {downloadRevenuesData?.primary_details?.ship_to_address
                  ? downloadRevenuesData?.primary_details?.ship_to_address
                  : "NA"}
              </Text>
            </View>
          )}
        </View>
        <View style={{ alignItems: "flex-end", maxWidth: "45%" }}>
          <View style={styles.sub_header_without_bottom_margin}>
            <View
              style={{
                ...styles.flexColumn,
                alignItems: "flex-start",
                width: "50%",
              }}
            >
              <Text style={styles.ras_pollypack_text_sub_header}>
                {renderDocumentType(downloadRevenuesData?.primary_details?.document_type?.label)} No.
              </Text>
              <Text style={styles.ras_pollypack_text}>
                {downloadRevenuesData?.primary_details?.voucher_invoice_number
                  ? downloadRevenuesData?.primary_details
                    ?.voucher_invoice_number
                  : "NA"}
              </Text>
            </View>
            <View
              style={{
                ...styles.flexColumn,
                marginLeft: "10%",
                width: "50%",
              }}
            >
              <Text style={styles.ras_pollypack_text_sub_header}>
                {renderDocumentType(downloadRevenuesData?.primary_details?.document_type?.label)} Date
              </Text>

              <Text style={styles.ras_pollypack_text}>
                {downloadRevenuesData?.primary_details?.voucher_invoice_date
                  ? formatDate(
                    downloadRevenuesData?.primary_details
                      ?.voucher_invoice_date
                  )
                  : "NA"}
              </Text>
            </View>
          </View>
          <View style={styles.sub_header_without_bottom_margin}>
            <View
              style={{
                ...styles.flexColumn,
                alignItems: "flex-start",
                width: "50%",
              }}
            >
              <Text style={styles.ras_pollypack_text_sub_header}>
                Delivery Note
              </Text>
              <Text style={styles.ras_pollypack_text}>
                {downloadRevenuesData?.primary_details?.delivery_note
                  ? downloadRevenuesData?.primary_details?.delivery_note
                  : "NA"}
              </Text>
            </View>
            <View
              style={{
                ...styles.flexColumn,
                marginLeft: "10%",
                width: "50%",
              }}
            >
              <Text style={styles.ras_pollypack_text_sub_header}>
                Mode/Terms of Payment
              </Text>

              <Text style={styles.ras_pollypack_text}>
                {downloadRevenuesData?.primary_details?.mode_or_terms_of_payment
                  ? downloadRevenuesData?.primary_details
                    ?.mode_or_terms_of_payment
                  : "NA"}
              </Text>
            </View>
          </View>
          <View style={styles.sub_header_without_bottom_margin}>
            <View
              style={{
                ...styles.flexColumn,
                alignItems: "flex-start",
                width: "50%",
              }}
            >
              <Text style={styles.ras_pollypack_text_sub_header}>
                Reference No & Date
              </Text>
              <Text style={styles.ras_pollypack_text}>
                {downloadRevenuesData?.primary_details?.reference_no
                  ? downloadRevenuesData?.primary_details?.reference_no
                  : "NA"}
              </Text>
              <Text style={styles.ras_pollypack_text}>
                {downloadRevenuesData?.primary_details?.reference_date
                  ? formatDate(
                    downloadRevenuesData?.primary_details?.reference_date
                  )
                  : ""}
              </Text>
            </View>
            <View
              style={{
                ...styles.flexColumn,
                marginLeft: "10%",
                width: "50%",
              }}
            >
              <Text style={styles.ras_pollypack_text_sub_header}>
                Other References
              </Text>

              <Text style={styles.ras_pollypack_text}>
                {downloadRevenuesData?.primary_details?.other_references
                  ? downloadRevenuesData?.primary_details?.other_references
                  : "NA"}
              </Text>
            </View>
          </View>
          <View style={styles.sub_header_without_bottom_margin}>
            <View
              style={{
                ...styles.flexColumn,
                alignItems: "flex-start",
                width: "50%",
              }}
            >
              <Text style={styles.ras_pollypack_text_sub_header}>
                Buyer's Order No.
              </Text>
              <Text style={styles.ras_pollypack_text}>
                {downloadRevenuesData?.primary_details?.buyer_order_no
                  ? downloadRevenuesData?.primary_details?.buyer_order_no
                  : "NA"}
              </Text>
            </View>
            <View
              style={{
                ...styles.flexColumn,
                marginLeft: "10%",
                width: "50%",
              }}
            >
              <Text style={styles.ras_pollypack_text_sub_header}>Dated</Text>

              <Text style={styles.ras_pollypack_text}>
                {downloadRevenuesData?.primary_details?.buyer_order_date
                  ? formatDate(
                    downloadRevenuesData?.primary_details?.buyer_order_date
                  )
                  : "NA"}
              </Text>
            </View>
          </View>
          <View style={styles.sub_header_without_bottom_margin}>
            <View
              style={{
                ...styles.flexColumn,
                alignItems: "flex-start",
                width: "50%",
              }}
            >
              <Text style={styles.ras_pollypack_text_sub_header}>
                Dispatch Doc No.
              </Text>
              <Text style={styles.ras_pollypack_text}>
                {downloadRevenuesData?.primary_details?.dispatch_doc_no
                  ? downloadRevenuesData?.primary_details?.dispatch_doc_no
                  : "NA"}
              </Text>
            </View>
            <View
              style={{
                ...styles.flexColumn,
                marginLeft: "10%",
                width: "50%",
              }}
            >
              <Text style={styles.ras_pollypack_text_sub_header}>
                Delivery Note Date
              </Text>

              <Text style={styles.ras_pollypack_text}>
                {downloadRevenuesData?.primary_details?.delivery_note_date
                  ? formatDate(
                    downloadRevenuesData?.primary_details?.delivery_note_date
                  )
                  : "NA"}
              </Text>
            </View>
          </View>
          <View style={styles.sub_header_without_bottom_margin}>
            <View
              style={{
                ...styles.flexColumn,
                alignItems: "flex-start",
                width: "50%",
              }}
            >
              <Text style={styles.ras_pollypack_text_sub_header}>
                Dispatched through
              </Text>
              <Text style={styles.ras_pollypack_text}>
                {downloadRevenuesData?.primary_details?.dispatch_through
                  ? downloadRevenuesData?.primary_details?.dispatch_through
                  : "NA"}
              </Text>
            </View>
            <View
              style={{
                ...styles.flexColumn,
                marginLeft: "10%",
                width: "50%",
              }}
            >
              <Text style={styles.ras_pollypack_text_sub_header}>
                Destination
              </Text>

              <Text style={styles.ras_pollypack_text}>
                {downloadRevenuesData?.primary_details?.destination
                  ? downloadRevenuesData?.primary_details?.destination
                  : "NA"}
              </Text>
            </View>
          </View>
          <View style={styles.sub_header_without_bottom_margin}>
            <View
              style={{
                ...styles.flexColumn,
                alignItems: "flex-start",
                width: "50%",
              }}
            >
              <Text style={styles.ras_pollypack_text_sub_header}>
                Bill of lading/LR-RR No
              </Text>
              <Text style={styles.ras_pollypack_text}>
                {downloadRevenuesData?.primary_details?.lr_rr_no
                  ? downloadRevenuesData?.primary_details?.lr_rr_no
                  : "NA"}
                {downloadRevenuesData?.primary_details?.bill_of_lading
                  ? ` ${downloadRevenuesData?.primary_details?.bill_of_lading}`
                  : ""}
              </Text>
            </View>
            <View
              style={{
                ...styles.flexColumn,
                marginLeft: "10%",
                width: "50%",
              }}
            >
              <Text style={styles.ras_pollypack_text_sub_header}>
                Motor Vehicle No.
              </Text>

              <Text style={styles.ras_pollypack_text}>
                {downloadRevenuesData?.primary_details?.vehicle_no
                  ? downloadRevenuesData?.primary_details?.vehicle_no
                  : "NA"}
              </Text>
            </View>
          </View>
          <View
            style={{ alignContent: "flex-start", width: "100%", marginTop: 6 }}
          >
            <Text style={styles.sub_header}>Terms of Delivery :</Text>
            <Text style={styles.text}>
              {downloadRevenuesData?.primary_details?.terms_of_delivery
                ? downloadRevenuesData?.primary_details?.terms_of_delivery
                : "NA"}
            </Text>

            {downloadRevenuesData?.primary_details?.place_of_supply?.label?.split(
              "-"
            )[0]?.length ? (
              <View style={styles.flexCenter}>
                <Text style={styles.sub_header}>State/UT Code: </Text>
                <Text style={styles.text}>
                  {
                    downloadRevenuesData?.primary_details?.place_of_supply?.label?.split(
                      "-"
                    )[0]
                  }
                </Text>
              </View>
            ) : null}

            {downloadRevenuesData?.primary_details?.place_of_supply?.value ? (
              <View style={styles.flexCenter}>
                <Text style={styles.sub_header}>Place of supply : </Text>
                <Text style={styles.text}>
                  {
                    downloadRevenuesData?.primary_details?.place_of_supply
                      ?.value
                  }
                </Text>
              </View>
            ) : null}

            <View style={styles.flexCenter}>
              <Text style={styles.sub_header}>Due Date : </Text>
              <Text style={styles.text}>
                {downloadRevenuesData?.primary_details?.due_date
                  ? formatDate(downloadRevenuesData?.primary_details?.due_date)
                  : "NA"}
              </Text>
            </View>
          </View>
        </View>
      </View>

      {/* third column  */}
      <View
        style={{
          ...styles.sub_header_1,
          display: "flex",
          justifyContent: "space-between",
          gap: "10%",
        }}
      >
        <View
          style={{ alignItems: "flex-start", maxWidth: "40%", marginTop: -15 }}
        ></View>

        <View
          style={{
            alignItems: "flex-end",
            width: "40%",
          }}
        ></View>
      </View>
    </View>
  );
};

export default BillFromAndLogo;
